define([
    'angular',
    'angulartics',
    'angulartics-google-tag-manager',
    './advertising/app',
    'angular-animate',
    './campaign/app',
    './directives/form',
    './directives/foundation',
    './directives/layout',
    './directives/tooltip',
    'angularjs-facebook',
    './lead/app',
    './services/errorHandler',
    './site/app',
    './site/directives/googlePlaces',
    './user/app',
    'jquery-migrate', // Needed for Foundation 5.5.3
    'foundation-sites',
    'foundation-dropdown',
    'jquery',
    'ng-country-select',
], function (angular) {
    'use strict';

    var angularModules = [
        'advertisingApp',
        'angulartics.google.tagmanager',
        'campaignApp',
        'countrySelect',
        'errorHandlerService',
        'facebook',
        'formDirectives',
        'foundationDirectives',
        'google.places',
        'layoutDirectives',
        'leadApp',
        'siteApp',
        'tooltipDirectives',
        'userApp',
    ];

    if (typeof Raven != 'undefined' && Raven) {
        angularModules.push('ngRaven');
    }

    return angular
        .module('app', angularModules)
        .config([
            'FacebookProvider',
            function (FacebookProvider) {
                if (window.facebookAppId) {
                    FacebookProvider.init(window.facebookAppId);
                    FacebookProvider.setSdkVersion('v16.0');
                }
            },
        ])
        .run([
            '$rootScope',
            '$state',
            '$location',
            '$anchorScroll',
            function ($rootScope, $state, $location, $anchorScroll) {
                $rootScope.state = $state;

                // Expose FOS js routing to all Angular controllers
                $rootScope.Routing = Routing;

                // Make sure foundation's JS components get initialized
                $rootScope.$on('$viewContentLoaded', function () {
                    if ($location.hash()) {
                        $anchorScroll();
                    }
                    $(document).foundation();
                });

                // Update title
                $rootScope.$on('$stateChangeSuccess', function (
                    event,
                    current,
                    previous
                ) {
                    if (current.hasOwnProperty('title')) {
                        $rootScope.title = current.title;
                    } else {
                        $rootScope.title = '';
                    }
                });
            },
        ]);
});
